module.exports = __webpack_public_path__ + "img/i_power.c932fa9d.svg";